import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m16 16 6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 8 6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 7 8 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 11-8-8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Gavel";
const Gavel = memo(themed(Icon));
export {
  Gavel
};
//# sourceMappingURL=gavel.js.map
